import { render } from "./EnquiryLogs.vue?vue&type=template&id=3b7698c3"
import script from "./EnquiryLogs.vue?vue&type=script&lang=js"
export * from "./EnquiryLogs.vue?vue&type=script&lang=js"

import exportComponent from "/home/paiscaler-travelcrmdev/htdocs/travelcrmdev.paiscaler.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__